import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useDashboardCardTitleStyles = makeStyles<Theme, { color?: string }>({
  root: {
    width: '100%'
  },
  title: {
    fontSize: '17px',
    fontWeight: 600,
    color: ({ color = 'black' }) => color
  }
});
